export default "__VITE_ASSET__U0p2Drud__"